// extracted by mini-css-extract-plugin
export var cardHeader = "_f4-1";
export var contentCard = "_f4-0";
export var headerActions = "_f4-3";
export var reorderHandle = "_f4-5";
export var titleArea = "_f4-2";
export var titleAreaWithHandle = "_f4-4";